export default __webpack_public_path__ + "static/media/E. Gold Short Sword.da3e98f0.PNG";